import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const LEGAL_LINKS = [
  { to: '/terms', label: 'Terms & Conditions', testId: 'footer-terms' },
  { to: '/privacy', label: 'Privacy Policy', testId: 'footer-privacy' },
  { to: '/partner-terms', label: 'Partner Terms', testId: 'footer-partner-terms' },
  { to: '/safety-policy', label: 'Safety Policy', testId: 'footer-safety' },
];

/**
 * Shared compact footer with legal links.
 *   <PublicFooter variant="dark" /> for landing-page-style dark surfaces
 *   <PublicFooter variant="light" /> (default) for white app surfaces
 *   <PublicFooter variant="minimal" /> small inline strip for login pages
 */
export default function PublicFooter({ variant = 'light' }) {
  if (variant === 'minimal') {
    return (
      <div className="text-center text-[11px] text-slate-400 pt-6 pb-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-testid="public-footer-minimal">
        {LEGAL_LINKS.map((l) => (
          <Link key={l.to} to={l.to} data-testid={l.testId} className="hover:text-slate-700 underline-offset-2 hover:underline">
            {l.label}
          </Link>
        ))}
      </div>
    );
  }

  const isDark = variant === 'dark';
  return (
    <footer
      data-testid="public-footer"
      className={`border-t mt-12 ${isDark ? 'bg-slate-900 text-slate-300 border-slate-800' : 'bg-slate-50 text-slate-600 border-slate-200'}`}
    >
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-2 text-sm">
          <ShieldCheck className={`h-4 w-4 ${isDark ? 'text-rose-300' : 'text-rose-600'}`} />
          <span className="font-medium">BeautyMateUK</span>
          <span className={`text-xs ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>© {new Date().getFullYear()}</span>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={`hover:underline underline-offset-4 ${isDark ? 'hover:text-white' : 'hover:text-slate-900'}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
